import React from "react";
import { useQuantities } from "./useQuantities";

export const useActivationFilters = (projectId: string) => {
  const quantities = useQuantities(projectId);

  return React.useMemo(
    () =>
      quantities
        .map(q => ({
          quantityId: q.id,
          min: q.minActivation,
          max: q.maxActivation,
          maxStd: q.maxStdActivation,
        }))
        .filter(f => f.min !== null || f.max !== null || f.maxStd !== null),
    [quantities],
  );
};

export type ActivationFilter = ReturnType<typeof useActivationFilters>[number];

export default useActivationFilters;
